<template>
  <div class="position-relative bg-image-color-2 pb-5 cta-buttons-image image-bg-overlay cta-bg" style="padding-top: 9em !important">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-12">
          <!--One Search Form-->
          <form @submit="searchPrimo()" class="row g-3 justify-content-center" action="https://csub-primo.hosted.exlibrisgroup.com/primo-explore/search" enctype="application/x-www-form-urlencoded; charset=utf-8" method="get" name="searchForm" target="_self">
            <!-- Customizable Parameters -->
            <input type="hidden" name="institution" value="01CALS_UBA">
            <input type="hidden" name="vid" value="01CALS_UBA">
            <input type="hidden" name="tab" value="EverythingVE" id="primoTab">
            <input type="hidden" name="search_scope" value="Everything_1" id="primoScope">
            <input type="hidden" name="mode" value="Basic">

            <!-- Fixed parameters -->
            <input type="hidden" name="displayMode" value="full">
            <input type="hidden" name="bulkSize" value="10">
            <input type="hidden" name="highlight" value="true">
            <input type="hidden" name="dum" value="true">
            <input type="hidden" name="query" id="primoQuery">
            <input type="hidden" name="displayField" value="all">

            <!-- Enable this if "Expand My Results" is enabled by default in Views Wizard -->
            <input type="hidden" name="pcAvailabiltyMode" value="true">

            <div class="oneSearchLogo">
              <a href="https://csub.libguides.com/UsingOneSearch" target="_blank"><img src="/library/static/images/onesearch-logo.png" alt="One Search" /></a>
              <p>Search for books, articles, videos, and more.</p>
            </div>

            <!-- ensure that the option values are set to the correct primo tab values for the selected scope -->
            <div class="col-auto">
              <div style="display: none"><label for="oneSearch_lookup">collection</label></div>
              <select id="oneSearch_lookup" aria-label="Search Scope" title="collection" class="form-select h-100" @change="primoScopeSwitch($event)">
                <option value="everything" selected>Everything</option>
                <option value="books_local">Books, Articles &amp; Media (CSUB)</option>
                <option value="outside">Outside CSU Bakersfield</option>
              </select>
            </div>
            <div class="col-4">
              <div style="display:none"><label for="primoQueryTemp">search</label></div>
              <input aria-label="Search Scope" title="lookfor" class="form-control h-100" type="text" id="primoQueryTemp" placeholder="What are you looking for today?">
            </div>
            <div class="col-auto">
              <button id="go" class="btn btn-primary" type="button" aria-label="Go" @click="searchPrimo()"><i class="fa-solid fa-magnifying-glass"></i></button>
            </div>
          </form>

          <div class="col-auto addLinks">
            <ul>
              <li v-for="(link, index) in lineOne" v-bind:key="index"><a :href="link.url">{{ link.title }}</a></li>
            </ul>
            <ul>
              <li v-for="(link, index) in lineTwo" v-bind:key="index"><a :href="link.url">{{ link.title }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    root: String
  },
  data () {
    return {
      lineOne: [],
      lineTwo: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/onesearch-links.json?nocache' + (new Date()).getTime())
    this.lineOne = jsonData.links1
    this.lineTwo = jsonData.links2
  },

  methods: {
    searchPrimo: function () {
      // Submits the search form
      document.getElementById('primoQuery').value = 'any,contains,' + document.getElementById('primoQueryTemp').value.replace(/[,]/g, ' ')
      document.forms.searchForm.submit()
    },
    primoScopeSwitch: function (event) {
      // Changes form variables depending on the selected scope
      switch (event.target.value) {
        // Double check that the scope values are correct
        case 'books_local':
          document.getElementById('primoTab').value = 'BAMCSUB'
          document.getElementById('primoScope').value = 'MyInst_and_CI'
          document.getElementById('primoQueryTemp').placeholder = 'Search items found here in the library'
          break

        case 'outside':
          document.getElementById('primoTab').value = 'Rapido'
          document.getElementById('primoScope').value = 'Rapido'
          document.getElementById('primoQueryTemp').placeholder = 'Search items from outside of CSUB'
          break

        case 'everything':
        default:
          document.getElementById('primoTab').value = 'Everything'
          document.getElementById('primoScope').value = 'Everything_1'
          document.getElementById('primoQueryTemp').placeholder = 'Discover books, articles, videos, and more'
      }
      // document.getElementById('primoTab').value = event.target.value // Set the primo tab value from the selected option
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      /* this.positionOneSearch()
      window.addEventListener('resize', this.positionOneSearch)
      this.iframeSelected()
      document.getElementById('iframe').contentDocument.addEventListener('click', this.iframeSelected)
      document.body.addEventListener('click', this.iframeDeselected) */
    })
  },
  updated: function () {
    this.$nextTick(function () {
      /* this.positionOneSearch()
      window.addEventListener('resize', this.positionOneSearch)
      this.iframeSelected()
      document.getElementById('iframe').contentDocument.addEventListener('click', this.iframeSelected)
      document.body.addEventListener('click', this.iframeDeselected) */
    })
  }
}
</script>

<style scoped>
  .cta-bg {
    background-image: url('https://www.csub.edu/library/static/images/hero/onesearch-bg.png');
    background-position: right 0%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media (min-width: 768px) {
    #oneSearch_lookup {
      left: auto;
      /* right: 45px; */
      width: auto;
    }
  }

  .addLinks ul {
    list-style: none;
    text-align: center;
    margin-top: 10px;
  }

  .addLinks ul li {
    display: inline-block;
    margin: 5px 10px;
  }

  .addLinks a:link, .addLinks a:visited {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
  }

  .oneSearchLogo {
    text-align: center;
  }
  .oneSearchLogo p {
    font-weight: bold;
    margin-top: 10px;
    color: #ffffff;
    text-shadow: 2px 2px #654;
  }

  .pt-5 {
    padding-top: 6rem !important;
  }
</style>
